export const coveragesList = [
	{
		code: 0,
		description: 'Capital fallecimiento por cualquier causa',
		tooltip:
			'Allianz garantiza el pago de un capital cuando se produzca el fallecimiento del asegurado por cuarquier causa.',
	},
	{
		code: 1,
		description: 'Capital adicional fallecimiento por accidente',
		tooltip:
			'Allianz garantiza el pago de un capital adicional al anterior en caso de que el fallecimiento del asegurado se produzca por accidente.',
	},
	{
		code: 2,
		description: 'Capital adicional fallecimiento por accidente de circulación',
		tooltip:
			'Allianz garantiza el pago de un capital adicional a los anteriores en caso de que el fallecimiento del asegurado se produzca por accidente de circulación.',
	},
	{
		code: 3,
		description: 'Gastos de sepelio, hasta',
		tooltip:
			'Allianz garantiza el pago de los gastos de sepelio según límites indicados en la póliza.',
	},
	{
		code: 4,
		description: 'Gastos de liquidación del Impuesto de Sucesiones y Donaciones, hasta',
		tooltip:
			'Allianz garantiza el pago de las cuotas tributarias del Impuesto de Sucesiones y Donaciones, según límites indicados en la póliza.',
	},
	{
		code: 5,
		description: 'Testamento notarial Online',
		tooltip:
			'Allianz garantiza la asistencia online en la elaboración o modificación, junto con el apoyo de un abogado, de un testamento notarial online.',
	},
	{
		code: 6,
		description: 'Orfandad por accidente',
		tooltip:
			'Allianz garantiza el pago de un capital a los hijos menores o incapacitados totalmente para el trabajo en caso de orfandad por fallecimiento simultáneo en el mismo accidente de ambos progenitores, adoptantes, tutores o ambos miembros de la pareja de hecho o de derecho inscrita en el Registro de Parejas correspondiente de cada CCAA del beneficiario designado.',
	},
	{
		code: 7,
		description: 'Renta por enfermedad crítica (durante 6 meses máximo)',
		tooltip:
			'Allianz garantiza el pago de una renta mensual en caso de que al asegurado se le declare una enfermedad definida en la póliza como crítica.',
	},
	{
		code: 8,
		description: 'Capital Invalidez permanente y absoluta con opción de transformar a renta(*)',
		tooltip:
			'Allianz garantiza el pago de una renta mensual en caso de que al asegurado se le diagnostique una invalidez absoluta y permanente.',
	},
	{
		code: 9,
		description:
			'Capital Invalidez permanente y absoluta por accidente con opcion de transformar a renta(*)',
		tooltip:
			'Allianz garantiza el pago de una renta adicional al anterior en caso de que la invalidez absoluta y permanente se produzca por la ocurrencia de un accidente.',
	},
];

export const coveragesTypes = coveragesList.reduce((acc, item) => {
	acc[item.code] = item.description;
	return acc;
}, {});
